import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 40px;
    border-radius: 16px;
    background: ${theme.v2.colors.brand.gradientBlue};
    margin-bottom: 16px;
    width: 100%;

    @media (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 24px 24px 0 0;
      margin-bottom: 0px;
      z-index: 10;
    }
  `}
`;

export const AnimationWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    border-radius: 50%;
    height: 32px;
    min-width: 32px;
    overflow:  hidden;
  `}
`;

export const AnimationIcon = styled.img`
  height: 32px;
  width: 32px;
`;

export const TextWrapper = styled.div`
  ${({ theme, $noIcon }) => css`
    display: flex;
    flex-direction: ${$noIcon ? 'column' : 'row'};
    gap: ${$noIcon ? 4 : 16}px;
    color: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};

    @media (max-width: ${theme.breakpoints.md}) {
      justify-content: center;
      align-items: center;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin-bottom: 4px;

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.font.sizes.xs};
    }
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;

    @media (max-width: ${theme.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;

export const ButtonContainer = styled.div`
  min-width: max-content;

  ${({ theme }) => css`
    @media (max-width: ${theme.breakpoints.md}) {
      width: 100%;
    }
  `}
`;
